export const coldEmailNavigationArticle = {
  title: 'Cold Email Engine: Navigation & Insights',
  slug: 'cold-email-navigation',
  content: `Cold Email Engine: Navigation & Insights

The left navigation organizes the cold email workflow.

Main
- Overview, Campaigns, Inbox, and Leads.

Manage
- Contacts, Mailboxes, and Templates.

Insights
- Analytics, Deliverability, Campaign Comparison, and A/B Tests.

Tips
- Use the sidebar groups to keep outreach work separate from analytics.
- Use the Inbox for replies once campaigns are active.
`,
};
